export enum WifiOutletDriver {
    ShellyGen2PlusRpc = 'shelly-gen2-plus-rpc',
}
